import PosActions from '../../../actions/PosActions';
import PosCartActions from '../../../actions/PosCartActions';
import PrintActions from '../../../actions/PrintActions';

import UserStore from '../../../stores/UserStore';
import PosStore from '../../../stores/PosStore';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as PosCartEndPoints } from '../../../constants/PosCartConstants';

import Price from '../../form/Price.react';

import Printing from '../../../utils/Printing';

class PreOrder extends React.Component {

    constructor(props) {
        super(props);

        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
        this.removePreOrder = this.removePreOrder.bind(this);
    }

    componentWillReceiveProps(next) {
        var preOrders = next.preOrders;

        if (preOrders.length === 0 && PosStore.getState().sidebarPage === 'pre-order') {
            setTimeout(() => {
                PosActions.setSidebarPage('profile');
                setTimeout(() => { PosActions.toggleSidebar('close'); }, 10);
            }, 10);
        }
    }

    searchForPreOrder(item) {
        var formData            = UserStore.getApiData();
        formData.SearchString   = item.Product;

        PosActions.productSearch(formData, this.props.guest.Guest_id);
        this.props.onSearch('productSearch', item.Product);
    }

    removePreOrder(item) {
        var formData = UserStore.getApiData();
        formData.ProdId = item.ProductId;
        formData.AcctId = this.props.guest.Guest_id;
        // formData.OrderId = item.OrderId;
        // formData.OrderItemId = item.OrderItemId;
        AjaxPromises.POST(PosCartEndPoints.REMOVE_PRE_ORDER,
            formData
        ).then(res => {
            formData.TransactionId = this.props.guest.ShipmentId;
            PosCartActions.loadPreOrders(formData);
        });
    }

    render() {
        var self = this;
    	var guest = this.props.guest;
        var preOrders = this.props.preOrders;

    	if (!guest)
            return null;

        return ([
            <div className='pos-sidebar__content'>
                <div
                    className='pos-pre-orders'>

                    <div className='pos-pre-orders__title'>
                        Pre-Orders

                        { preOrders.length > 0 &&
                            <div
                                className='pos-pre-orders__print'
                                onClick={() => { PrintActions.printPreOrderReceipt(guest); }}>
                                <i className='fa fa-print' />
                            </div>
                        }
                    </div>

                    <table
                        className='pre-orders-table'>
                        <thead>
                            <tr>
                                <th>Qty</th>
                                <th>Product</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            { preOrders.map((item, i) => {

                                return (
                                    <tr key={item.uuid}>

                                        <td onClick={self.searchForPreOrder.bind(self, item)}>
                                            { item.UnitId ==1 ? item.QtySelected : `${item.Grams} ${item.abbreviation}`}
                                        </td>

                                        <td onClick={self.searchForPreOrder.bind(self, item)}>
                                            {item.Product}
                                        </td>

                                        <td onClick={self.searchForPreOrder.bind(self, item)}>
                                            <Price price={item.TotalCost} />
                                        </td>

                                        <td onClick={self.removePreOrder.bind(self, item)}>
                                            <i className='fa fa-times' aria-hidden='true' />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
	        </div>,
            <div id='PrintPreOrderCart'>
                { preOrders.map((item, i) => {

                    return (
                        <div>
                            {item.QtySelected} x {item.Product}
                        </div>
                    )
                })}
            </div>
        ]);
    }
}

export default PreOrder;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/PreOrder.react.jsx